import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import ReactECharts from 'echarts-for-react';

export const DetalleCuentaGrafica = ({ anioSeleccionado, cargando, dataActual }) => {
    if(!dataActual) return null;

    const getOption = () => {
        return {
            tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
            legend: { data: ['Ingresos', 'Egresos'], bottom: 0 },
            grid: { left: '3%', right: '4%', bottom: '10%', containLabel: true },
            xAxis: [
                { type: 'category', data: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'] }
            ],
            yAxis: [
                { type: 'value', axisLabel: { formatter: '${value}' } }
            ],
            series: [
                { name: 'Ingresos', type: 'bar', itemStyle: { color: '#2ecc71', borderRadius: [4, 4, 0, 0] }, data: dataActual.ingresos },
                { name: 'Egresos', type: 'bar', itemStyle: { color: '#e74c3c', borderRadius: [4, 4, 0, 0] }, data: dataActual.egresos }
            ]
        };
    };

    return (
        <Card className="h-100 shadow-sm border-0 bg-light">
            <Card.Body>
                <h6 className="fw-bold text-secondary mb-3">Ingresos vs Egresos - {anioSeleccionado}</h6>
                {!cargando && (
                    <ReactECharts option={getOption()} style={{ height: '300px' }} />
                )}
            </Card.Body>
        </Card>
    );
};

DetalleCuentaGrafica.propTypes = {
    anioSeleccionado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    cargando: PropTypes.bool.isRequired,
    dataActual: PropTypes.shape({
        ingresos: PropTypes.array,
        egresos: PropTypes.array
    })
};
